import React from "react";
import { ReactNode } from "react";
import ObservableState from "../utils/ObservableState";
import * as ui from "../native";
import ObservableComponent from "./ObservableComponent";
import BaseUIProps, { copyBaseUIProps } from "../native/ui/BaseUIProps";
import Device from "../utils/Device";
import MaterialIcons from "../icons/MaterialIcons";
import PageNavigator from "../classes/PageNavigator";
import IconButton from "./IconButton";
import Admin from "../models/Admin";
import Query from "../classes/Query";
import { BuildContext } from "../classes/BuildContext";

export interface AdminHeaderProps extends BaseUIProps {
  key?: string;
  admin: Admin;
}

class _AdminHeaderState extends ObservableComponent<AdminHeaderProps> {
  static defaultProps = { admin: null };
  static contextType = BuildContext;
  context: React.ContextType<typeof BuildContext>;
  public constructor(props: AdminHeaderProps) {
    super(props);

    this.initState();
  }
  public get admin(): Admin {
    return this.props.admin;
  }
  public initState() {
    super.initState();

    this.initListeners();

    this.enableBuild = true;
  }
  public initListeners(): void {
    this.updateSyncProperty("admin", this.props.admin);
  }
  public componentDidUpdate(prevProps: AdminHeaderProps): void {
    super.componentDidUpdate(prevProps);

    if (prevProps.admin !== this.props.admin) {
      this.updateObservable("admin", prevProps.admin, this.props.admin);

      this.fire("admin", this);
    }
  }
  public render(): ReactNode {
    let cStyle = this.context.theme;

    return ui.Row({
      mainAxisAlignment: ui.MainAxisAlignment.end,
      children: [
        ui.Container({
          decoration: new ui.BoxDecoration({
            color: cStyle.c1,
            border: ui.Border.all({
              color: new ui.Color(0xff0000),
              width: 0.0,
            }),
            borderRadius: ui.BorderRadius.circular(7.0),
          }),
          margin: ui.EdgeInsets.symmetric({
            horizontal: 10.0,
            vertical: 0.0,
            transitions: new Map(),
          }),
          padding: ui.EdgeInsets.all(10.0, new Map()),
          child: IconButton({
            icon: MaterialIcons.power_settings_new,
            color: cStyle.c5,
            size: 20,
            tooltip: "Logout",
            onPressed: () => {
              this.onPressedMenuButtonHandler();
            },
          }),
          key: "0",
          className: "x5c9",
        }),
      ],
      className: ui.join(this.props.className, "AdminHeader xc4e hc h"),
      ...copyBaseUIProps(this.props),
    });
  }
  public onPressedMenuButtonHandler = async (): Promise<void> => {
    Device.put("email", null);

    Device.put("password", null);

    let result: boolean = await Query.get().logout();

    this.navigator.pushAdminLoginPage();
  };
  public get navigator(): PageNavigator {
    return PageNavigator.of(this.context);
  }
}
export default function AdminHeader(props: AdminHeaderProps) {
  return React.createElement(_AdminHeaderState, {
    ..._AdminHeaderState.defaultProps,
    ...props,
  });
}
